import { Controller } from "@hotwired/stimulus"

// This controller is used to persist the form data in the URL params
// How to use it:
// 1. Add the data-controller="persist-form-data" attribute to the form
// 2. Add the data-persist-form-data-object-name-value attribute to the form
// 3. Add the data-action="click->persist-form-data#persistFormData" attribute to the link
// 4. in your #new routes, you can access the form data in the session[:objectName] 

export default class extends Controller {
  static values = {
    objectName: String
  }
  
  declare readonly objectNameValue: string

  persistFormData(event: Event) {
    // Get all form values
    const form = this.element.closest('form') as HTMLFormElement
    const formData = new FormData(form)
    
    // Start with existing URL parameters instead of empty
    const link = event.currentTarget as HTMLAnchorElement
    const url = new URL(link.href)
    const searchParams = new URLSearchParams(url.search)
    
    // Add form data to URL params, keeping only the nested values
    formData.forEach((value, key) => {
      if (key.startsWith(`${this.objectNameValue}[`)) {
        searchParams.append(key, value.toString())
      }
    })
    
    // Include disabled radio buttons that are checked
    const disabledRadios = form.querySelectorAll('input[type="radio"]:disabled:checked')
    disabledRadios.forEach((radio: Element) => {
      const radioInput = radio as HTMLInputElement
      const name = radioInput.name
      const value = radioInput.value
      if (name && name.startsWith(`${this.objectNameValue}[`)) {
        searchParams.append(name, value)
      }
    })
    
    // Update the link's href with the combined parameters
    url.search = searchParams.toString()
    link.href = url.toString()
  }
} 